module.exports = __webpack_public_path__ + "static/img/foot-bg.d7d7052.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/foot-bg.png
// module id = NQ7D
// module chunks = 1